import script from "./MProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfile.vue?vue&type=script&setup=true&lang=js"

import "./MProfile.vue?vue&type=style&index=0&id=4d4ed8d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4ed8d9"]])

export default __exports__